<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbar_timeout"
      :color="snackbar_color"
      :top="true" >
      {{ snackbar_message }}
    </v-snackbar>

    <v-card flat class="mt-5" >
      <v-card-title>
        <h6 class="primary--text">Liste des types d'acteurs</h6>
        <v-spacer></v-spacer>

        <v-btn rounded color="primary" class="text-capitalize" v-if="$can('create actors type')">
          <export-excel
            :data = "actor_types"
            name = "ActorTypes.xls"
            :export-fields ="actor_types_fields">
            Exporter
            <v-icon right>mdi-share-outline</v-icon>
          </export-excel>
        </v-btn>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog_edit" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn rounded color="primary" dark class="mb-2" v-on="on" v-if="$can('create actors type')">
              Ajouter <v-icon right>mdi-plus-circle-outline</v-icon>
          </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.name" label="Nom du  type d'acteur" solo></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" rounded @click="dialog_edit = false">Fermer</v-btn>
              <v-btn color="primary" rounded @click="save">Enregistrer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher un  type d'acteur"
          single-line
          solo
          hide-details>
        </v-text-field>
      </v-card-title>
    </v-card>
  <v-data-table
    :headers="headers"
    :items="actor_types"
    :loading="loading"
    loading-text="Loading..."
    :search="search"
    class="elevation-1">
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
        v-if="$can('edit actors type')">
        mdi-pencil-outline
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
        v-if="$can('delete actors type')">
        mdi-trash-can-outline
      </v-icon>
    </template>
  </v-data-table>

  <v-layout row justify-center>
    <v-dialog
      v-model="dialog_deletion"
      max-width="290">
      <v-card>
        <v-card-title class="headline">Suppression</v-card-title>
        <v-card-text class="text-center">
         Etes-vous sûr de vouloir supprimer ce type d'acteur?
        </v-card-text>

        <v-card-actions>

          <v-btn
            color="orange"
            rounded
            @click="dialog_deletion = false">
             <span class="white-couleur">Non</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            rounded
            @click="delActorType()">
            Oui
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';

export default {
  name: 'settings-actor-type',
  mixins: [Permissions],
  data: () => ({
    del_actor_type: null,
    del_index: null,
    search: '',
    loading: false,
    dialog_edit: false,
    dialog_deletion: false,
    headers: [
          { text: "Type d'acteur", value: 'name' },
          { text: 'Actions', value: 'action', sortable: false }
        ],
    actor_types_fields : {
          "Type d'acteur": "name",
      },
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',

    editedIndex: -1,
    editedItem: {
      name: '',
      country_id: null,
    },
    defaultItem: {
      name: '',
      country_id: null,
    },

  }),

  created () {
    this.loading = true
    this.fetchUtils();
    this.loading = false
  },

  computed: {
    pays () { return this.$store.getters.countries; },
    actor_types () { return this.$store.getters.actor_types; },
    formTitle () {
        return this.editedIndex === -1 ? "Nouveau  type d'acteurs" : "Editer type d'acteur"
      },
  },

  watch: {
      dialog (val) {
        val || this.close()
      },
    },

  methods: {
    fetchUtils () {
      this.$store.dispatch("fetchCountries");
      this.$store.dispatch("fetchActorTypes");
    },

    editItem (item) {
      this.editedIndex = this.actor_types.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_edit = true
    },

    deleteItem (item) {
      this.del_index = this.actor_types.indexOf(item);
      this.dialog_deletion = true;
      this.del_actor_type = item;
    },

    close () {
      this.dialog_edit = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      if (this.editedIndex > -1) {
        await this.$store.dispatch("updateActorType", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Type d'acteur édité avec succès !";
      }
      else {
        await this.$store.dispatch("createActorType", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Type d'acteur enregistré avec succès !";
      }
      this.close();
    },


    async delActorType(){
      await this.$store.dispatch("deleteActorType", this.del_actor_type);
      this.dialog_deletion = false;
      this.snackbar = true;
      this.snackbar_color = 'success';
      this.snackbar_message = "Type d'acteur supprimé avec succès !";
    },
  }

};
</script>

<style scoped>
.white-couleur{
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/actor-types/list.vue